// FIT REPORT V2 - 측정 데이터 기반 점수 계산용 EXERCISE 설정.
// BatchEntry.js의 EXERCISE_CONFIG와 동일한 구조 (V2 전용 사본 - 기존 페이지 영향 방지).
export const FIT_REPORT_EXERCISE_CONFIG = {
  strength: {
    label: '근력',
    exercises: [
      { value: 'deadlift', label: '데드리프트' },
      { value: 'squat', label: '스쿼트' },
      { value: 'bench_press', label: '벤치프레스' },
      { value: 'shoulder_press', label: '숄더프레스' },
    ],
    // 모든 strength 종목 공통 컬럼
    columns: ['weight_kg', 'reps'],
    columnLabels: { weight_kg: '수행무게(kg)', reps: '반복횟수(1-5)' },
  },
  muscular_endurance: {
    label: '근지구력',
    exercises: [
      { value: 'pushup', label: '푸시업', columns: ['reps'] },
      { value: 'situp', label: '싯업', columns: ['reps'] },
      { value: 'barbell_squat_endurance', label: '바벨 스쿼트', columns: ['reps', 'input_load_kg'] },
      { value: 'barbell_deadlift_endurance', label: '바벨 데드리프트', columns: ['reps', 'input_load_kg'] },
      { value: 'barbell_shoulder_press_endurance', label: '바벨 숄더프레스', columns: ['reps', 'input_load_kg'] },
      { value: 'plank', label: '플랭크', columns: ['seconds'] },
      { value: 'wall_squat', label: '월 스쿼트', columns: ['seconds'] },
      { value: 'amrap1', label: 'AMRAP1', columns: ['amrap_minutes', 'amrap_record'] },
      { value: 'amrap2', label: 'AMRAP2', columns: ['amrap_minutes', 'amrap_record'] },
      { value: 'amrap3', label: 'AMRAP3', columns: ['amrap_minutes', 'amrap_record', 'weight_kg', 'weight_adjustment'] },
      { value: 'amrap4', label: 'AMRAP4', columns: ['amrap_minutes', 'amrap_record'] },
    ],
    columns: ['reps'],
    columnLabels: {
      reps: '횟수(3분)',
      input_load_kg: '사용중량(kg)',
      seconds: '유지시간(초)',
      amrap_minutes: '시간(분)',
      amrap_record: '기록 (X.YY)',
      weight_kg: '사용무게(kg)',
      weight_adjustment: '무게보정(점)',
    },
  },
  cardio: {
    label: '심폐지구력',
    exercises: [
      { value: 'running', label: '러닝' },
      { value: 'rowing', label: '로잉' },
    ],
    columns: ['distance_m', 'duration_seconds'],
    columnLabels: { distance_m: '거리(m)', duration_seconds: '시간(초)' },
  },
};

/** 종목별 컬럼 목록 반환 (종목별 override > 카테고리 기본) */
export function columnsForExercise(category, exerciseValue) {
  const cat = FIT_REPORT_EXERCISE_CONFIG[category];
  if (!cat) return [];
  const ex = cat.exercises.find((e) => e.value === exerciseValue);
  if (ex && ex.columns) return ex.columns;
  return cat.columns || [];
}

/** 컬럼 label */
export function columnLabel(category, col) {
  const cat = FIT_REPORT_EXERCISE_CONFIG[category];
  return cat?.columnLabels?.[col] || col;
}
